import * as React from "react";

import { InputContainer, InputContainerProps } from "./input-container";

export interface SingleLineTextInputProps extends InputContainerProps {
  className?: string;

  onFocus?: (name: string) => void;
  onChange: (name: string, value: string) => void;
  onBlur: (name: string) => void;

  placeholder?: string;

  type?: string;
  autoComplete?: string;
}

export const SingleLineTextInput: React.FunctionComponent<
  SingleLineTextInputProps
> = (props) => {
  return (
    <InputContainer
      {...props}
      className={`single-line-text-input ${props?.className || ""}`}
    >
      <div className="input-immediate-container">
        <input
          type={props.type ? props.type : "text"}
          name={props.name}
          value={props.form[props.name] || ""}
          onFocus={() => props.onFocus?.(props.name)}
          onChange={(event) => props.onChange(props.name, event.target.value)}
          onBlur={() => props.onBlur(props.name)}
          placeholder={props.placeholder}
          title={props.displayName}
          autoComplete={props.autoComplete}
        />
        {props?.children}
      </div>
    </InputContainer>
  );
};
